module.exports = __webpack_public_path__ + "static/media/empty.2703f81c.png";